import React from 'react';
import PropTypes from 'prop-types';
import SubmitSpinner from '../../common/Spinners/SubmitSpinner/SubmitSpinner'
import LinkActionButton from '../../common/Buttons/LinkActionButton/LinkActionButton'
import SuccessCheckMessage from '../../common/SuccessCheckMessage/SuccessCheckMessage'
import { Row, Col, Form} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import * as styles from './_AdviserDataDump.scss'
import withStyles from 'isomorphic-style-loader/withStyles'

const AdviserDataDump = ({
  downloading,
  downloaded,
  downloadCurrentData
}) => (
  <div >
    <h1 className={styles['heading']}>Data Dump</h1>
    <Row>
      <Col xs={12} sm={12} md={6} lg={6}>
        <Form.Group>
          <Form.Label>Download data dump</Form.Label>
          <div className={styles['download-button']}>
            <LinkActionButton buttonText={'Download '} onClick={downloadCurrentData}>
              <FontAwesome name={'download'} />
            </LinkActionButton>
            {downloading && <SubmitSpinner />}
            {downloaded && <SuccessCheckMessage message={'Download complete.'} />}
          </div>
        </Form.Group>
      </Col>
    </Row>
  </div>
  )

AdviserDataDump.propTypes = {
  downloading: PropTypes.bool.isRequired,
  downloaded: PropTypes.bool.isRequired,
  downloadCurrentData: PropTypes.func.isRequired
}

export default  (AdviserDataDump)
